import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
  useTheme,
  useMediaQuery,
  Slide
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ModalSeguroDetalhes({
  open,
  onClose,
  children,
  maxWidth = "md",
  fullScreen = false
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={true}
      fullScreen={fullScreen || isMobile}
      TransitionComponent={Transition}
      sx={{
        '& .MuiDialog-paper': {
          margin: { xs: 1, md: 2 },
          width: '100%',
          maxHeight: { xs: '95vh', md: '90vh' },
          borderRadius: { xs: 2, md: 3 },
          overflow: 'hidden'
        }
      }}
    >
      {/* Botão de fechar no canto superior direito */}
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          zIndex: 1300
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            bgcolor: 'background.paper',
            boxShadow: 2,
            '&:hover': {
              bgcolor: 'grey.100'
            }
          }}
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent 
        sx={{ 
          p: 0,
          '&:first-of-type': {
            padding: 0
          }
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
}